import { Module } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import actions from './actions'
import getters from './getters'

export const giftCardStore: Module<{}, RootState> = {
  namespaced: true,
  state: {},
  actions,
  getters
}
